export function toStringWithPad(num: number): string {
  if (num < 10) {
    return "0" + num;
  }
  return num < 10 ? 0 + num.toString() : num.toString();
}

export function dateFromAPIString(dateStr: string) {
  return new Date(dateStr);
}

export function dateToAPIString(date: Date) {
  return (
    date.getFullYear() +
    "-" +
    toStringWithPad(date.getMonth() + 1) +
    "-" +
    toStringWithPad(date.getDate()) +
    "T" +
    toStringWithPad(date.getHours()) +
    ":" +
    toStringWithPad(date.getMinutes()) +
    ":" +
    toStringWithPad(date.getSeconds())
    //"." +
    //(date.getMilliseconds() / 1000).toFixed(3).slice(2, 5)
  );
}

export function AppendParams(url: string, params: any) {
  let query = Object.keys(params)
    .map(
      (k) =>
        encodeURIComponent(k) +
        "=" +
        encodeURIComponent(params[k] === undefined ? "" : params[k])
    )
    .join("&");
  return url + "?" + query;
}
